import React from "react";
import { MDBContainer, MDBModal, MDBModalBody, MDBModalHeader } from "mdbreact";
import styles from "./style.module.scss";
import partnerId from "~/utils/partner";

class Alert extends React.Component {
  render() {
    const { isModal, message, toggleAlert } = this.props;
    return (
      <MDBContainer>
        <MDBModal
          isOpen={!!isModal}
          toggle={toggleAlert}
          centered
          className={styles["Alert_" + partnerId]}
        >
          <MDBModalHeader toggle={toggleAlert} className={styles.modal_header}>
            <i className="fas fa-bell" /> Thông báo !
          </MDBModalHeader>
          <MDBModalBody>{message}</MDBModalBody>
        </MDBModal>
      </MDBContainer>
    );
  }
}
export default Alert;
